import { createRouter, createWebHistory } from 'vue-router';
import Homepage from './views/HomeView.vue';
import Aboutpage from './views/AboutView.vue';
import Contactpage from './views/ContactView.vue';
import Portfoliopage from './views/PortfolioView.vue';


const routes = [
  { path: '/', name: 'Home', component: Homepage },
  { path: '/about', name: 'About', component: Aboutpage },
  { path: '/contact', name: 'Contact', component: Contactpage },
{ path: '/portfolio', name: 'Portfolio', component: Portfoliopage },

];


const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
